import { render } from "./BuyCredits.vue?vue&type=template&id=ede02ce6&scoped=true&ts=true"
import script from "./BuyCredits.vue?vue&type=script&lang=ts"
export * from "./BuyCredits.vue?vue&type=script&lang=ts"

import "./buyCredits.scss?vue&type=style&index=0&id=ede02ce6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede02ce6"]])

export default __exports__